export default function DS_Regression_Coefficients() {
  return <div>DS_Regression_Coefficients Component</div>;
}
